module.exports = __webpack_public_path__ + "img/shiyili.ce92d179.png";